import { useState } from 'react';
import { Link } from 'react-router-dom';
import Icon from './Icons';
import { site, praca, monograma, linkWhatsApp } from '../config';
import { SLUG_BRASILIA } from '../seo';
import './Hero.css';

const destaques = [
  'Atendimento em todos os estados do Brasil',
  'Do inquérito policial ao STJ e ao STF',
  `Presencial em ${praca} e por videoconferência no restante do país`,
];

export default function Hero() {
  // Enquanto a foto real não for adicionada em public/imagens/,
  // exibimos um bloco elegante no lugar — sem imagem quebrada.
  const [semFoto, setSemFoto] = useState(false);

  return (
    <section className="hero" id="inicio">
      <div className="hero__fundo" aria-hidden="true" />

      <div className="container hero__interno">
        <div className="hero__conteudo">
          <span className="rotulo">Advocacia Criminal · Todo o Brasil</span>

          {/* O H1 é o termo nacional. A marca vem logo abaixo, no subtítulo:
              a busca por "advogado criminalista" é muito maior do que a
              busca pelo nome, e o H1 precisa responder a ela. */}
          <h1 className="hero__titulo">
            {site.cargo}
            <span>
              {site.nome} · {site.oab}
            </span>
          </h1>

          <p className="hero__texto">
            Defesa criminal em todas as fases da persecução penal, para clientes
            de qualquer estado. Base em {praca} — onde ficam o Superior Tribunal
            de Justiça e o Supremo Tribunal Federal.
          </p>

          <ul className="hero__destaques">
            {destaques.map((item) => (
              <li key={item}>
                <Icon name="check" size={17} />
                {item}
              </li>
            ))}
          </ul>

          <div className="hero__acoes">
            <a
              className="btn btn--ouro"
              href={linkWhatsApp()}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Icon name="whatsapp" size={18} />
              Falar pelo WhatsApp
            </a>
            <a className="btn btn--contorno" href="#areas">
              Áreas de atuação
              <Icon name="seta" size={18} />
            </a>
          </div>

          <p className="hero__oab">
            <Link to={`/${SLUG_BRASILIA}`}>
              <Icon name="local" size={15} />
              Atendimento presencial em {praca}
            </Link>
          </p>
        </div>

        <div className="hero__midia">
          <div className="hero__moldura">
            {semFoto ? (
              <div className="hero__placeholder">
                <span aria-hidden="true">{monograma}</span>
                <p>img</p>
              </div>
            ) : (
              <img
                src={`${process.env.PUBLIC_URL}/imagens/advogado.png`}
                alt={`${site.nome}, ${site.cargo.toLowerCase()}`}
                onError={() => setSemFoto(true)}
                loading="eager"
                fetchPriority="high"
                /* Proporção declarada evita o salto de layout (CLS) enquanto
                   a imagem carrega. Ajuste se trocar o corte da foto. */
                width="1000"
                height="1250"
              />
            )}
          </div>
          <div className="hero__selo">
            <Icon name="urgencia" size={22} />
            <div>
              <strong>Plantão 24 horas</strong>
              <span>Prisão em flagrante e casos urgentes</span>
            </div>
          </div>
        </div>
      </div>

      <a className="hero__rolar" href="#sobre" aria-label="Ir para a próxima seção">
        <span />
      </a>
    </section>
  );
}
